import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BaseComponent } from '@base/component/base.component';
import { getGuestToken } from 'src/app/api/auth';
import { getProfile } from 'src/app/api/users';

@Component({
  selector: 'app-root',
  templateUrl: '../view/app.component.html',
  styleUrls: []
})

export class AppComponent extends BaseComponent {
  isHeaderAllowed: boolean;
  isFooterAllowed: boolean

  constructor(public router: Router) {
    super();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isHeaderAllowed = this.isComponentAllowed("header");
        this.isFooterAllowed = this.isComponentAllowed("footer");
      }
    });
  }

  async ngOnInit() {
    // Deprecated proyect, so we redirect the user
    window.location.href = 'https://oneplay.net/'; 
    await this.fillAuthenticationData();
    // this.changeBackground(this.router.url);
    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.changeBackground(event.urlAfterRedirects);
    //   }
    // });
  }

  async fillAuthenticationData() {
    const { isLoggedIn, token } = BaseComponent.fillAuthData();
    if (!token) 
      await getGuestToken();
    if (isLoggedIn)
      await getProfile(this.userId.toString());
  }
  changeBackground(url: string) {
    const gradientRoutes = ['/profile', '/edit-profile', '/search', '/category', '/favorite', '/watchlist'];
    if (gradientRoutes.some(route => url.startsWith(route))) {
      document.body.style.background = 'linear-gradient(136deg, #000 0%, #320632 100%)';
    } else {
      document.body.style.background = 'black';
    }
  }

  isComponentAllowed(componentName: string) {
    const notAllowedPages = {
      "header": ["auth", "forgot-password", "set-new-password", "video-page", "trailer-page"],
      "footer": ["auth", "forgot-password", "set-new-password", "video-page", "trailer-page"]
    }

    const currentPageName = window.location.pathname.split("/")[1];
    return !notAllowedPages[componentName].includes(currentPageName || "/");
  }
}
